import { render, staticRenderFns } from "./AddBackupDocumentModal.vue?vue&type=template&id=77a61722&scoped=true"
import script from "./AddBackupDocumentModal.vue?vue&type=script&lang=js"
export * from "./AddBackupDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./AddBackupDocumentModal.vue?vue&type=style&index=0&id=77a61722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a61722",
  null
  
)

export default component.exports